module.exports = __webpack_public_path__ + "img/locationPics.9963308d.png";